module.exports = {
	api_server: 'https://api.huemn.com/galleries/2.3',
	proposal_api_server: 'https://api.huemn.com/proposals/1.0',
	tenant_user_api_server: 'https://api.huemn.com/tenant-users/1.0',
	tenant_api_server: 'https://api.huemn.com/tenants/1.0',
	//tenant_api_server: 'http://192.168.3.244:3000',
	notification_api_server: 'https://api.huemn.com/notifications/1.0',
	image_api_server: 'https://api.huemn.com/images/1.0/',
	form_api_server: 'https://api.huemn.com/forms/2.0',
	projects_api_server: 'https://api.huemn.com/projects/1.0',
	graphql_server: `https://api.huemn.com/projects/1.0/`,
	forms_graphql_server: `https://api.huemn.com/forms/2.0`,
	vendors_api_server: 'https://api.huemn.com/projects/1.0/vendors',
	//vendors_api_server: 'http://192.168.0.194:8765/vendors',
};
